// Parser for Warmane/CavernOfTime raid statistics HTML specifically for
// Ulduar. Warmane does not distinguish Normal/Heroic for Ulduar in the
// descriptions, so treat 10NM==10HC and 25NM==25HC by emitting both codes
// for each source row.
// Exports parseTableUlduar(html) -> array of { boss, code, value, rawDesc, rawValue }

function cleanHtml(raw) {
  if (!raw) return '';
  let s = raw.replace(/\\+/g, '');
  s = s.replace(/<\s*\/\s*/g, '</');
  s = s.replace(/<\s+/g, '<');
  s = s.replace(/\s+>/g, '>');
  s = s.replace(/\s+/g, ' ');
  return s;
}

function extractRows(html) {
  const rows = [];
  const trRe = /<tr\b[^>]*>([\s\S]*?)<\/tr>/gi;
  let m;
  while ((m = trRe.exec(html)) !== null) rows.push(m[1]);
  return rows;
}

function extractTds(trInner) {
  const tds = [];
  const tdRe = /<td\b[^>]*>([\s\S]*?)<\/td>/gi;
  let m;
  while ((m = tdRe.exec(trInner)) !== null) {
    const inner = m[1].replace(/<[^>]+>/g, '').trim();
    tds.push(inner);
  }
  return tds;
}

function normalizeBoss(desc) {
  if(!desc) return '';
  // Remove trailing parenthetical like "(Ulduar 10 player)" or "(Ulduar 25 player)"
  let s = desc.replace(/\s*\([^)]*Ulduar[^)]*\)\s*$/i, '').trim();
  // Remove trailing words like 'kills' or 'victories'
  s = s.replace(/\b(kills|victories)\b\s*$/i, '').trim();
  return s;
}

export function parseTableUlduar(html) {
  const cleaned = cleanHtml(html || '');
  const tbodyMatch = cleaned.match(/<tbody[^>]*>([\s\S]*?)<\/tbody>/i);
  const body = tbodyMatch ? tbodyMatch[1] : cleaned;
  const rows = extractRows(body);
  const out = [];
  for (const rowInner of rows) {
    const tds = extractTds(rowInner);
    if (tds.length < 2) continue;
    const desc = (tds[0] || '').trim();
    const valRaw = (tds[1] || '').trim();

    // Determine 10 vs 25 from parenthetical
    const is10 = /Ulduar\s*10/i.test(desc);
    const is25 = /Ulduar\s*25/i.test(desc);

    const boss = normalizeBoss(desc);

    let value = null;
    const v = valRaw.replace(/,/g, '').trim();
    if (/^-+$/i.test(v) || v === '') value = null;
    else {
      const n = parseInt(v, 10);
      value = Number.isNaN(n) ? null : n;
    }

    // For each numeric row, emit both NM and HC codes for the size since Ulduar
    // does not separate them in the source. This makes 10NM==10HC and 25NM==25HC.
    if (is10) {
      out.push({ boss, code: 'ULDUAR 10NM', value, rawDesc: desc, rawValue: valRaw });
      out.push({ boss, code: 'ULDUAR 10HC', value, rawDesc: desc, rawValue: valRaw });
    } else if (is25) {
      out.push({ boss, code: 'ULDUAR 25NM', value, rawDesc: desc, rawValue: valRaw });
      out.push({ boss, code: 'ULDUAR 25HC', value, rawDesc: desc, rawValue: valRaw });
    } else {
      // Fallback: if neither 10 nor 25 is present, still attempt to emit a 10/25 pair
      out.push({ boss, code: 'ULDUAR 10NM', value, rawDesc: desc, rawValue: valRaw });
      out.push({ boss, code: 'ULDUAR 10HC', value, rawDesc: desc, rawValue: valRaw });
    }
  }
  return out;
}

const exported = { parseTableUlduar };
export default exported;
